import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import { FS } from "@plannel/utils/font-util";

// iOS 스타일 세그먼트 컨트롤 — 단일 선택(연결된 버튼 하나 = 다중선택 오해 방지).
//   연한 트랙 + 둥근 청록 thumb. options: [{ value, label, disabled? }], onChange(value) => void.
const SEGMENTED_GROUP_SX = {
  display: "inline-flex", flexWrap: "wrap",
  bgcolor: "grey.100", borderRadius: 5, p: "3px", gap: "2px",
  "& .MuiToggleButtonGroup-grouped": {
    m: 0, border: 0, borderRadius: "16px !important",
    textTransform: "none", fontSize: FS.TITLE, px: 1.9, py: 0.5,
    color: "text.secondary",
    "&:hover": { bgcolor: "action.hover" },
    "&.Mui-selected": {
      bgcolor: "primary.main", color: "primary.contrastText", fontWeight: 600,
      boxShadow: "0 1px 3px rgba(0,0,0,0.15)",
      "&:hover": { bgcolor: "primary.dark" },
    },
    // 위 color 가 MUI 기본 Mui-disabled 색을 덮으므로 명시한다(안 쓰면 비활성이 보이지 않음).
    "&.Mui-disabled": { color: "text.disabled", bgcolor: "transparent" },
  },
  /*
    ToggleButtonGroup 은 "붙은 버튼 한 덩어리"가 기본이라, 첫 버튼을 뺀 나머지에
    marginLeft:-1 + borderLeft:1px 를 넣어 이웃과 테두리를 겹쳐 공유한다(MuiToggleButtonGroup-middleButton/lastButton).
    여기 세그먼트는 gap 으로 떨어뜨린 알약 4개라 그 -1px 이 남으면 알약끼리 1px 씩 파고들어
    이음매가 겹쳐 보인다. 비활성 상태엔 borderLeft 규칙이 (0,3,0) 으로 한 번 더 붙어서 특히 도드라진다.

    위 블록의 m/border 는 (0,2,0) 이라 그 규칙들을 못 이긴다 → &&& 로 (0,4,0) 을 만들어 확실히 덮는다.
    (pages/ai/AiSegmentedControl 이 && 를 쓰는 것도 같은 이유다.)
  */
  "&&& .MuiToggleButtonGroup-firstButton, &&& .MuiToggleButtonGroup-middleButton, &&& .MuiToggleButtonGroup-lastButton": {
    margin: 0,
    border: 0,
    borderRadius: "16px",
  },
};

// allowEmpty — 「아무것도 선택 안 함」이 정상 상태인 필터 축만 opt-in 한다(활성 세그먼트 재클릭 시 해제).
//   기본값 false 는 현행과 항등이라 설정 화면 등 기존 사용처는 재클릭해도 선택이 유지된다.
//   ⚠️ ...rest 로 새면 DOM unknown-prop 경고가 나므로 반드시 구조분해로 흡수한다.
const SegmentedControl = ({ value, onChange, options, allowEmpty = false, sx, ...rest }) => (
  <ToggleButtonGroup
    exclusive
    value={value}
    onChange={(_e, v) => { if (v !== null || allowEmpty) onChange(v); }}
    size="small"
    sx={{ ...SEGMENTED_GROUP_SX, ...sx }}
    {...rest}
  >
    {(options ?? []).map(opt => (
      <ToggleButton key={opt.value} value={opt.value} disabled={opt.disabled}>{opt.label}</ToggleButton>
    ))}
  </ToggleButtonGroup>
);

export default SegmentedControl;
